export enum OfferRequestType {
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
}
